import React, { useEffect } from 'react'
import { Form } from 'antd'
import { Formik } from 'formik'
import { object, string } from 'yup'
import { useDispatch } from 'react-redux'

import { Alert, Button } from 'src/components/Ant'
import { authSuccess } from 'src/core/store/ducks/auth/actions'
import {
  getMeSuccess,
  getOrganizationSuccess
} from 'src/core/store/ducks/me/actions'
import { Input, InputPassword } from 'src/components/Formik'
import { useAuthContext } from 'src/contexts/auth'
import history from 'src/config/routes/history'
import useAuth from 'src/hooks/use-auth'

import * as CSS from './styles'

interface Props {
  shareUsername: (value?: string) => string
  toggle: () => void
}

const initialValues = { password: '', login: '' }

const validationSchema = object().shape({
  login: string()
    .trim()
    .matches(
      /[A-Za-z0-9]{1,}@{1}[A-Za-z0-9.]{1,}/,
      'web.login.username.invalid'
    )
    .required(),
  password: string().trim().required()
})

export default function Login({ shareUsername, toggle }: Props): JSX.Element {
  const dispatch = useDispatch()
  const authContext = useAuthContext()

  const { authByUsername, error, loading } = useAuth()

  /**
   * Remove after refactor
   */
  useEffect(() => {
    if (
      authContext.accessToken &&
      authContext.organization &&
      authContext.user
    ) {
      dispatch(
        authSuccess({
          access_token: authContext.accessToken,
          refresh_token: authContext.accessToken
        })
      )
      // @ts-ignore
      dispatch(getMeSuccess(authContext.user))
      // @ts-ignore
      dispatch(getOrganizationSuccess(authContext.organization))

      history.push(
        authContext.organization.tenant &&
          authContext.organization.tenant.tenant_type === 'AGENCY'
          ? '/agencies/issuances'
          : '/my-requests'
      )
    }
  }, [
    authContext.accessToken,
    authContext.organization,
    authContext.user,
    dispatch
  ])

  return (
    <Formik
      {...{ initialValues, validationSchema }}
      onSubmit={({ login, password }) => {
        authByUsername({ login: login.trim().toLowerCase(), password })
      }}
      render={formikProps => (
        <CSS.WrapForm onSubmit={formikProps.handleSubmit}>
          {!!error && (
            <Form.Item>
              <Alert message={error} />
            </Form.Item>
          )}
          <Input
            autoFocus
            data-test-id="login-username"
            formikProps={formikProps}
            label="web.login.username.title"
            name="login"
            onChange={value => {
              shareUsername(value.target.value)
            }}
            placeholder="web.login.username.placeholder"
            prefix={<CSS.WrapIcon type="user" />}
          />
          <InputPassword
            data-test-id="login-password"
            formikProps={formikProps}
            label="web.login.password.title"
            name="password"
            placeholder="web.login.password.placeholder"
          />
          <Form.Item>
            <CSS.WrapLink
              data-test-id="login-forgot-my-password"
              onClick={toggle}
              title="web.login.forgot-password"
            />
            <Button
              block
              data-test-id="login-submit"
              htmlType="submit"
              loading={loading}
              title="web.login.action-login"
            />
          </Form.Item>
        </CSS.WrapForm>
      )}
    />
  )
}
